export default async (axios, searchValue, page, limit, params = {}) => {
    const response = await axios.post('/UserManagement/GetClientAvailableRoleListing', {
    });

    const { data } = response;

    return {
        metadata: {
            page: 1,
            pages: 1,
        },
        result: data.map(item => ({
            label: item.name,
            key: item.id,
            item,
        })),
    };
};
